import { fields } from "./fields";
import { educationIds } from "@monorepo/utils/src/variables/educationIds";

export const filtersElements = [
  {
    value: fields.FILTER_ARCHIVE,
    title: "Архив",
    tooltip: "Выбор из списка с предиктивным вводом",
    type: "autocomplete",
    showSelectedKey: "name",
    autocompleteActionName: "getArchiveAutocompleteByCode",
    className: "filter-archive mt-4",
    width: 250,
    educationId: educationIds.listViewSettings,
  },
];
